var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_c('Canvas',{ref:"canvas",attrs:{"certificate":_vm.certificate,"tags":_vm.tags}}),_vm._v(" "),_c('a',{staticClass:"button is-primary is-large",attrs:{"title":"Baixar Certificado"},on:{"click":function($event){$event.preventDefault();return _vm.savePDF.apply(null, arguments)}}},[_c('span',[_vm._v("Baixar")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }